import { BaseService } from '../../../../core/services/base.service';
import { Package } from '../../interfaces/package/package.interface';
import { Observable } from 'rxjs';
import { PackageSearchParam } from '../../interfaces/package/package-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

export abstract class PackageService extends BaseService<Package> {
    findAll(searchParam: PackageSearchParam): Observable<PageResponse<Package>> { throw new Error('Not implemented'); }
    find(id: string): Observable<Package> { throw new Error('Not implemented'); }
    create(data: Partial<Package>): Observable<Package> { throw new Error('Not implemented'); }
    update(id: string, data: Partial<Package>): Observable<Package> { throw new Error('Not implemented'); }
    delete(id: string): Observable<void> { throw new Error('Not implemented'); }
}
